module.exports = __webpack_public_path__ + "static/media/agenda-menu-mobile.ee29a347.svg";